<template lang='pug'>
  .reward-card
    img.img(:src='reward.icon', :alt='reward.productName')
    .brand(v-text='reward.brandName')
    .description(v-text='reward.productName')
    .points(v-text='`${reward.points} points`')
</template>

<script>
export default {
  props: {
    reward: {
      type: Object,
      required: true
    }
  }
}
</script>

<style lang='scss' scoped>
  .reward-card {
    > .img {
      background: $white;
      height: 140px;
      width: 100%;
    }

    > .brand, .points {
      @include font-weight-medium;
      text-transform: capitalize;
    }
  }
</style>
